<template>
    <div class="ly-page-container">
        <h2 v-if="showTitle" class="subtitle">{{ title }}</h2>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "Page",
    props: {
        title: {
            type: String,
        },
        showTitle: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style scoped>
.subtitle {
    padding: 10px 10px;
}
</style>
